import {Controller} from "stimulus"
import Choices from "choices.js";

export default class extends Controller {

    connect() {
        if (this.choices) {
            return
        }

        const options = JSON.parse(this.element.dataset.choicesOptions ?? '{}' )

        // Select options are empty by default, and passed through choices-select-options.
        // Loop through the options and add them to the select element.
        const selectOptions = JSON.parse(this.element.dataset.choicesSelectOptions ?? '[]' )
        selectOptions.forEach((data) => {
            let option = document.createElement("option")
            option.text = data.name
            option.value = data.id
            this.element.add(option)
        })

        const choicesOptions = {
            ...{
                removeItemButton: true,
                placeholder: true,
                placeholderValue: 'All',
                itemSelectText: '',
                searchFields: ['label'],
                classNames: {
                    containerOuter: 'choices' + (this.element.required ? ' is-required' : ''),
                }
            },
            ...options
        }

        this.choices = new Choices(this.element, choicesOptions)
        this.originalPlaceholder = choicesOptions.placeholderValue
        this.data.set('connected', 1)
    }

    removeActiveItems() {
        if (!this.choices) {
            return
        }

        this.choices.removeActiveItems()
    }

    // tweaks the choices placeholder value to remove when items are selected
    updatePlaceholder() {
        if (!this.choices) {
            return
        }

        const count = this.choices.getValue(true).length

        if (count > 0) {
            this.choices.input.element.placeholder = ''
        } else {
            this.choices.input.element.placeholder = this.originalPlaceholder
            this.choices.input.setWidth && this.choices.input.setWidth()
        }
    }

    setValue(val) {
        this.choices.setChoiceByValue(val)
    }

    destroy() {
        this.choices.destroy();
    }
}
